'use client';

import React, { memo } from 'react';
import getHTML from '@shared/get-html';
import STYLE from './ProductDescription.module.scss';
import { allowedTags } from './config';

export interface ContentPropTypes {
    title: string;
    description: string;
}

const _StandardContent: React.FC<ContentPropTypes> = (props) => {
    const { title, description } = props;

    return (
        <div className={STYLE.productDescriptionItem}>
            <h2 className={STYLE.productDescriptionTitle}>{title}</h2>
            <hr className={STYLE.productDescriptionDivider} />
            {getHTML(
                description,
                'div',
                {
                    className: STYLE.productDescriptionContent,
                },
                {
                    domPurifyConfig: {
                        ALLOWED_TAGS: allowedTags,
                    },
                }
            )}
        </div>
    );
};

export const StandardContent = memo(_StandardContent);
